module.exports = __webpack_public_path__ + "img/kongjiangLOGO.e0cacaf2.png";